var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongXinjianwenjianjia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.5A.5.5 0 0014 4H7.707a.5.5 0 01-.353-.146L6.146 2.646a.5.5 0 00-.353-.146H2a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V4.5z",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 6.5a.5.5 0 00-1 0V8H6a.5.5 0 000 1h1.5v1.5a.5.5 0 001 0V9H10a.5.5 0 000-1H8.5V6.5z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_xinjianwenjianjia.739c476a.svg";
export { SvgTongyongXinjianwenjianjia as ReactComponent };